<template>
<div class="chapter">
<div class="inner_page">
<p class="epi"><a id="page_vi"></a>‘How charmingly and effectively these foreign tags assist one in the great task of calling a spade by some other name!’</p>
<p class="epir">Aldous Huxley, <em class="italic">Antic Hay</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Epigraph.vue?43e0e046